import { combineReducers } from 'redux';

import attachments from './attachments';
import document from './document';
import histories from './histories';
import host from './host';
import isFetching from './isFetching';
import participants from './participants';

export default combineReducers({
  attachments,
  document,
  histories,
  isFetching,
  participants,
  host,
});
